import React, { useState, useEffect } from 'react';
import * as tf from '@tensorflow/tfjs';

const TestModel = ({ modelPath }) => {
  const [status, setStatus] = useState('Initializing...');
  const [results, setResults] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    async function testModel() {
      try {
        setStatus('Loading model...');
        const modelUrl = `${process.env.PUBLIC_URL}/models/${modelPath}/model.json`;
        console.log(`Loading model from: ${modelUrl}`);

        // Load model
        const model = await tf.loadGraphModel(modelUrl);
        setStatus('Model loaded. Examining model...');

        // Log model details
        console.log(
          'Model inputs:',
          model.inputs.map((i) => ({
            name: i.name,
            shape: i.shape,
            dtype: i.dtype,
          }))
        );
        console.log(
          'Model outputs:',
          model.outputs.map((o) => ({
            name: o.name,
            shape: o.shape,
            dtype: o.dtype,
          }))
        );

        // Create a test image tensor (all zeros with shape [1, 224, 224, 3])
        setStatus('Creating test input...');
        const testInput = tf.zeros([1, 224, 3, 224]);
        console.log('Test input shape:', testInput.shape);

        // Run prediction
        setStatus('Running prediction...');
        const predictions = await model.predict(testInput);

        // Process results
        let predictionResults;
        if (Array.isArray(predictions)) {
          const ageData = await predictions[0].data();
          const genderData = await predictions[1].data();

          predictionResults = {
            age: Math.round(ageData[0] * 100),
            gender: genderData[0] > genderData[1] ? 'Male' : 'Female',
            confidence: Math.max(genderData[0], genderData[1]),
            rawAge: Array.from(ageData),
            rawGender: Array.from(genderData),
          };

          // Clean up tensors
          predictions.forEach((p) => p.dispose());
        } else {
          predictionResults = {
            error: 'Unexpected output format',
          };
          predictions.dispose();
        }

        testInput.dispose();
        setResults(predictionResults);
        setStatus('Test complete');
      } catch (err) {
        console.error('Test failed:', err);
        setError(err.message || 'Unknown error');
        setStatus('Test failed');
      }
    }

    testModel();
  }, [modelPath]);

  return (
    <div
      style={{
        padding: '20px',
        border: '1px solid #ccc',
        borderRadius: '8px',
        marginBottom: '20px',
      }}
    >
      <h3>Model Test: {modelPath}</h3>
      <p>Status: {status}</p>

      {error && (
        <div style={{ color: 'red', marginTop: '10px' }}>
          <strong>Error:</strong> {error}
        </div>
      )}

      {results && (
        <div style={{ marginTop: '10px' }}>
          <h4>Test Results:</h4>
          <pre
            style={{
              background: '#f5f5f5',
              padding: '10px',
              borderRadius: '4px',
              overflow: 'auto',
            }}
          >
            {JSON.stringify(results, null, 2)}
          </pre>
        </div>
      )}
    </div>
  );
};

export default TestModel;
